const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';
// Phase 4 / Plan 04-03 — remembers which composite the student inspected so
// the "Thông tin khối Robot" info modal renders the matching preview SVG.
const SET_ROBOT_BLOCK_INFO_KEY = 'scratch-gui/modals/SET_ROBOT_BLOCK_INFO_KEY';
// UC-43 / UC-47 management — carries the entry being edited so the EXT-01 /
// EXT-02 wizard opens prefilled (edit mode) instead of blank (create mode).
const SET_EXT_DEVICE_EDIT_ENTRY = 'scratch-gui/modals/SET_EXT_DEVICE_EDIT_ENTRY';
const SET_EXT_BLOCK_EDIT_ENTRY = 'scratch-gui/modals/SET_EXT_BLOCK_EDIT_ENTRY';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_TELEMETRY = 'telemetryModal';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_CONNECTION = 'connectionModal';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';
const MODAL_UPLOAD_PROGRESS = 'uploadProgress';
const MODAL_DEVICE_LIBRARY = 'deviceLibrary';
const MODAL_UPDATE = 'updateModal';

// Phase 2 / Plan 02-01 additions — 4 new manager modals.
const MODAL_THEME_MANAGER = 'themeManager';
const MODAL_ROBOT_MANAGER = 'robotManager';
const MODAL_KIT_MANAGER = 'kitManager';
const MODAL_FIRMWARE_WIZARD = 'firmwareWizard';

// Phase 3 / Plan 03-01 additions — 6 new project & tutorial modals.
const MODAL_NEW_PROJECT = 'newProjectModal';
const MODAL_OPEN_PROJECT = 'openProjectModal';
const MODAL_SAVE_PROJECT = 'saveProjectModal';
const MODAL_SHARE_PROJECT = 'shareProjectModal';
const MODAL_SHARED_PROJECTS = 'sharedProjectsModal';
const MODAL_TUTORIAL = 'tutorialModal';

// Phase 4 / Plan 04-01 addition — Robot block info modal ("Thông tin khối Robot").
const MODAL_ROBOT_BLOCK_INFO = 'robotBlockInfo';

// Phase 5 / Plan 05-01 addition — SmartHome monitoring dashboard ("Dashboard
// giám sát thiết bị"; consumed by the 05-03 dashboard-modal container).
const MODAL_SMARTHOME_DASHBOARD = 'smartHomeDashboard';

// Phase 6 / Plan 06-01 additions — 4 "Khối Mở rộng" authoring modals (EXT-01..04;
// fleshed out by 06-02..06-05). Additive flags, Object.assign style (DR-05).
const MODAL_DEVICE_DECLARATION = 'deviceDeclarationModal';
const MODAL_BLOCK_BUILDER = 'blockBuilderModal';
const MODAL_LED_DESIGNER = 'ledMatrixDesignerModal';
const MODAL_PUBLISH_WIZARD = 'publishWizardModal';

// UC-43 / UC-47 management — list/search/edit/delete views for declared
// devices (mstem.customDevices) and blocks (mstem.customBlocks). MOCK-ONLY.
const MODAL_EXT_DEVICE_MANAGER = 'extDeviceManagerModal';
const MODAL_EXT_BLOCK_MANAGER = 'extBlockManagerModal';

// Phase 7 / Plan 07-01 addition — AI control panel (AI-01; "Bảng điều khiển AI").
const MODAL_AI_PANEL = 'aiPanel';

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_TELEMETRY]: false,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_CONNECTION]: false,
    [MODAL_UPLOAD_PROGRESS]: false,
    [MODAL_DEVICE_LIBRARY]: false,
    [MODAL_TIPS_LIBRARY]: false,
    [MODAL_UPDATE]: false,
    [MODAL_THEME_MANAGER]: false,
    [MODAL_ROBOT_MANAGER]: false,
    [MODAL_KIT_MANAGER]: false,
    [MODAL_FIRMWARE_WIZARD]: false,
    [MODAL_NEW_PROJECT]: false,
    [MODAL_OPEN_PROJECT]: false,
    [MODAL_SAVE_PROJECT]: false,
    [MODAL_SHARE_PROJECT]: false,
    [MODAL_SHARED_PROJECTS]: false,
    [MODAL_TUTORIAL]: false,
    [MODAL_ROBOT_BLOCK_INFO]: false,
    [MODAL_SMARTHOME_DASHBOARD]: false,
    [MODAL_DEVICE_DECLARATION]: false,
    [MODAL_BLOCK_BUILDER]: false,
    [MODAL_LED_DESIGNER]: false,
    [MODAL_PUBLISH_WIZARD]: false,
    [MODAL_EXT_DEVICE_MANAGER]: false,
    [MODAL_EXT_BLOCK_MANAGER]: false,
    [MODAL_AI_PANEL]: false,
    // Which composite preview the info modal shows: 'lineFollow' | 'avoidObstacle' | 'followObject'.
    robotBlockInfoKey: 'lineFollow',
    // UC-43 / UC-47 management — entry currently loaded into the EXT-01 / EXT-02
    // wizard for editing (null = create mode). Cleared on save/close.
    extDeviceEditEntry: null,
    extBlockEditEntry: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    case SET_ROBOT_BLOCK_INFO_KEY:
        return Object.assign({}, state, {
            robotBlockInfoKey: action.key
        });
    case SET_EXT_DEVICE_EDIT_ENTRY:
        return Object.assign({}, state, {
            extDeviceEditEntry: action.entry
        });
    case SET_EXT_BLOCK_EDIT_ENTRY:
        return Object.assign({}, state, {
            extBlockEditEntry: action.entry
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openBackdropLibrary = function () {
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCostumeLibrary = function () {
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openExtensionLibrary = function () {
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openLoadingProject = function () {
    return openModal(MODAL_LOADING_PROJECT);
};
const openTelemetryModal = function () {
    return openModal(MODAL_TELEMETRY);
};
const openSoundLibrary = function () {
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    return openModal(MODAL_SOUND_RECORDER);
};
const openConnectionModal = function () {
    return openModal(MODAL_CONNECTION);
};
const openUploadProgress = function () {
    return openModal(MODAL_UPLOAD_PROGRESS);
};
const openDeviceLibrary = function () {
    return openModal(MODAL_DEVICE_LIBRARY);
};
const openTipsLibrary = function () {
    return openModal(MODAL_TIPS_LIBRARY);
};
const openUpdateModal = function () {
    return openModal(MODAL_UPDATE);
};
const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closeTelemetryModal = function () {
    return closeModal(MODAL_TELEMETRY);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closeConnectionModal = function () {
    return closeModal(MODAL_CONNECTION);
};
const closeUploadProgress = function () {
    return closeModal(MODAL_UPLOAD_PROGRESS);
};
const closeDeviceLibrary = function () {
    return closeModal(MODAL_DEVICE_LIBRARY);
};
const closeUpdateModal = function () {
    return closeModal(MODAL_UPDATE);
};
// Phase 2 / Plan 02-01 — open/close action creators for the 4 new manager modals.
const openThemeManager = function () {
    return openModal(MODAL_THEME_MANAGER);
};
const closeThemeManager = function () {
    return closeModal(MODAL_THEME_MANAGER);
};
const openRobotManager = function () {
    return openModal(MODAL_ROBOT_MANAGER);
};
const closeRobotManager = function () {
    return closeModal(MODAL_ROBOT_MANAGER);
};
const openKitManager = function () {
    return openModal(MODAL_KIT_MANAGER);
};
const closeKitManager = function () {
    return closeModal(MODAL_KIT_MANAGER);
};
const openFirmwareWizard = function () {
    return openModal(MODAL_FIRMWARE_WIZARD);
};
const closeFirmwareWizard = function () {
    return closeModal(MODAL_FIRMWARE_WIZARD);
};

// Phase 3 / Plan 03-01 — open/close action creators for the 6 new
// project & tutorial modals (PRJ-01..07 / LLD UC 06-12).
const openNewProjectModal = function () {
    return openModal(MODAL_NEW_PROJECT);
};
const closeNewProjectModal = function () {
    return closeModal(MODAL_NEW_PROJECT);
};
const openOpenProjectModal = function () {
    return openModal(MODAL_OPEN_PROJECT);
};
const closeOpenProjectModal = function () {
    return closeModal(MODAL_OPEN_PROJECT);
};
const openSaveProjectModal = function () {
    return openModal(MODAL_SAVE_PROJECT);
};
const closeSaveProjectModal = function () {
    return closeModal(MODAL_SAVE_PROJECT);
};
const openShareProjectModal = function () {
    return openModal(MODAL_SHARE_PROJECT);
};
const closeShareProjectModal = function () {
    return closeModal(MODAL_SHARE_PROJECT);
};
const openSharedProjectsModal = function () {
    return openModal(MODAL_SHARED_PROJECTS);
};
const closeSharedProjectsModal = function () {
    return closeModal(MODAL_SHARED_PROJECTS);
};
const openTutorialModal = function () {
    return openModal(MODAL_TUTORIAL);
};
const closeTutorialModal = function () {
    return closeModal(MODAL_TUTORIAL);
};

// Phase 4 / Plan 04-01 — open/close action creators for the Robot block info
// modal (DR-05 "Thông tin khối Robot"; consumed by the 04-03 info-modal container).
const openRobotBlockInfo = function () {
    return openModal(MODAL_ROBOT_BLOCK_INFO);
};
const closeRobotBlockInfo = function () {
    return closeModal(MODAL_ROBOT_BLOCK_INFO);
};
// Phase 4 / Plan 04-03 — selects which composite preview the info modal renders.
const setRobotBlockInfoKey = function (key) {
    return {
        type: SET_ROBOT_BLOCK_INFO_KEY,
        key: key
    };
};

// Phase 5 / Plan 05-01 — open/close action creators for the SmartHome
// monitoring dashboard modal (SMH-02; consumed by the 05-03 container).
const openSmartHomeDashboard = function () {
    return openModal(MODAL_SMARTHOME_DASHBOARD);
};
const closeSmartHomeDashboard = function () {
    return closeModal(MODAL_SMARTHOME_DASHBOARD);
};

// Phase 6 / Plan 06-01 — open/close action creators for the 4 "Khối Mở rộng"
// authoring modals (EXT-01 device declaration, EXT-02 block builder,
// EXT-03 LED 8×8 designer, EXT-04 publish wizard). Wired in menu-bar.jsx.
const openDeviceDeclaration = function () {
    return openModal(MODAL_DEVICE_DECLARATION);
};
const closeDeviceDeclaration = function () {
    return closeModal(MODAL_DEVICE_DECLARATION);
};
const openBlockBuilder = function () {
    return openModal(MODAL_BLOCK_BUILDER);
};
const closeBlockBuilder = function () {
    return closeModal(MODAL_BLOCK_BUILDER);
};
const openLedDesigner = function () {
    return openModal(MODAL_LED_DESIGNER);
};
const closeLedDesigner = function () {
    return closeModal(MODAL_LED_DESIGNER);
};
const openPublishWizard = function () {
    return openModal(MODAL_PUBLISH_WIZARD);
};
const closePublishWizard = function () {
    return closeModal(MODAL_PUBLISH_WIZARD);
};

// UC-43 / UC-47 management — open/close action creators for the two
// "Quản lý ... mở rộng" list/search/edit/delete modals + edit-entry setters
// that prefill the EXT-01 / EXT-02 wizard (null = create mode).
const openExtDeviceManager = function () {
    return openModal(MODAL_EXT_DEVICE_MANAGER);
};
const closeExtDeviceManager = function () {
    return closeModal(MODAL_EXT_DEVICE_MANAGER);
};
const openExtBlockManager = function () {
    return openModal(MODAL_EXT_BLOCK_MANAGER);
};
const closeExtBlockManager = function () {
    return closeModal(MODAL_EXT_BLOCK_MANAGER);
};
const setExtDeviceEditEntry = function (entry) {
    return {
        type: SET_EXT_DEVICE_EDIT_ENTRY,
        entry: entry
    };
};
const setExtBlockEditEntry = function (entry) {
    return {
        type: SET_EXT_BLOCK_EDIT_ENTRY,
        entry: entry
    };
};

// Phase 7 / Plan 07-01 — open/close action creators for the AI control panel
// (AI-01; opened from the "Bảng điều khiển AI" menu item, fleshed out by 07-03).
const openAiPanel = function () {
    return openModal(MODAL_AI_PANEL);
};
const closeAiPanel = function () {
    return closeModal(MODAL_AI_PANEL);
};
export {
    reducer as default,
    initialState as modalsInitialState,
    openBackdropLibrary,
    openConnectionModal,
    openCostumeLibrary,
    openDeviceLibrary,
    openExtensionLibrary,
    openLoadingProject,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openTelemetryModal,
    openTipsLibrary,
    openUploadProgress,
    openUpdateModal,
    closeBackdropLibrary,
    closeConnectionModal,
    closeCostumeLibrary,
    closeDeviceLibrary,
    closeExtensionLibrary,
    closeLoadingProject,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeTelemetryModal,
    closeTipsLibrary,
    closeUploadProgress,
    closeUpdateModal,
    openThemeManager,
    closeThemeManager,
    openRobotManager,
    closeRobotManager,
    openKitManager,
    closeKitManager,
    openFirmwareWizard,
    closeFirmwareWizard,
    openNewProjectModal,
    closeNewProjectModal,
    openOpenProjectModal,
    closeOpenProjectModal,
    openSaveProjectModal,
    closeSaveProjectModal,
    openShareProjectModal,
    closeShareProjectModal,
    openSharedProjectsModal,
    closeSharedProjectsModal,
    openTutorialModal,
    closeTutorialModal,
    openRobotBlockInfo,
    closeRobotBlockInfo,
    setRobotBlockInfoKey,
    MODAL_SMARTHOME_DASHBOARD,
    openSmartHomeDashboard,
    closeSmartHomeDashboard,
    MODAL_DEVICE_DECLARATION,
    MODAL_BLOCK_BUILDER,
    MODAL_LED_DESIGNER,
    MODAL_PUBLISH_WIZARD,
    openDeviceDeclaration,
    closeDeviceDeclaration,
    openBlockBuilder,
    closeBlockBuilder,
    openLedDesigner,
    closeLedDesigner,
    openPublishWizard,
    closePublishWizard,
    MODAL_EXT_DEVICE_MANAGER,
    MODAL_EXT_BLOCK_MANAGER,
    openExtDeviceManager,
    closeExtDeviceManager,
    openExtBlockManager,
    closeExtBlockManager,
    setExtDeviceEditEntry,
    setExtBlockEditEntry,
    MODAL_AI_PANEL,
    openAiPanel,
    closeAiPanel
};
